import { render, staticRenderFns } from "./SendMailHistoryDetail.vue?vue&type=template&id=16e218e7&"
import script from "./SendMailHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./SendMailHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./SendMailHistoryDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendMailHistoryDetail.vue"
export default component.exports